import { storeUserName } from "@/services/user/userService";
const mutations = {
  /**
   * Set current module
   * @param state
   * @param {{name:String, email:String, title:String}} payload
   * @constructor
   */
  // SET_USER: (state, payload) => {
  //   console.log(payload);
  //   state.user = payload;
  //   storeUserName(state.user.name);
  // },
  SET_USER(state) {
    const userName =
      state.keycloak && state.keycloak.idTokenParsed
        ? state.keycloak.idTokenParsed.preferred_username || null
        : null;

    state.user = userName;
    storeUserName(userName);
  },
  SET_APP_SETTINGS(state, appSettings) {
    state.appSettings = appSettings;
  },
  SET_KEYCLOAK(state, keycloak) {
    state.keycloak = keycloak;
  },
  LOGOUT(state) {
    try {
      state.user = null;
      state.keycloak.logout();
    } catch (error) {
      console.error(error);
    }
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  }
};

export default mutations;
